import {
    SET_SEARCH_BUTTON_STATUS
} from '../../actions';

const initialState = {
    boolean: true
}

function searchButtonReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_SEARCH_BUTTON_STATUS:
            newState.boolean = action.status;
            return newState;
        
        default:
            return state;

    }
}

export default searchButtonReducer;
